import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkin-code-sub",
  "use": "icon-checkin-code-sub-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-checkin-code-sub\">\r\n    <defs>\r\n        <style>#icon-checkin-code-sub .a{fill:#0062FF;}#icon-checkin-code-sub .b{fill:#fff;}</style>\r\n    </defs>\r\n    <circle class=\"a\" cx=\"10\" cy=\"10\" r=\"10\" />\r\n    <path class=\"b\" d=\"M0,0H8V2H0Z\" transform=\"translate(6 9)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/checkin-code-sub.svg
// module id = +jLH
// module chunks = 115